import { BPagination } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBPagination when migrating. */
export const EgBPagination = createEgBootstrapProxy(
  "EgBPagination",
  BPagination
);
